import React, { memo } from "react"
import { Translate } from "utils/i18n-shim"
import { Box, CircularProgress, Typography } from "@mui/material"

const TRACK_COLOR = "#DFDFDF"
const POSITIVE = { arc: "#9FD8AE", text: "#2E9E63" }
const NEGATIVE = { arc: "#F2A6A6", text: "#D2605F" }

/**
 * @param {object} props
 * @param {number|null} props.value - signed percentage change
 * @param {number} [props.size]
 * @param {number} [props.thickness]
 */
const PercentCircle = ({ value, size = 44, thickness = 4, sx, ...props }) => {
  const hasValue = value !== null && value !== undefined
  const isPositive = hasValue && value >= 0
  const { arc: arcColor, text: textColor } = isPositive ? POSITIVE : NEGATIVE
  const magnitude = hasValue ? Math.min(Math.abs(value), 100) : 0

  return (
    <Box
      sx={{ position: "relative", display: "inline-flex", ...sx }}
      data-testid="percent-circle"
      {...props}
    >
      <Box position="absolute" color={TRACK_COLOR}>
        <CircularProgress
          variant="determinate"
          value={100}
          size={size}
          thickness={thickness}
          color="inherit"
        />
      </Box>
      <CircularProgress
        variant="determinate"
        value={magnitude}
        size={size}
        thickness={thickness}
        sx={{
          color: arcColor,
          ...(isPositive
            ? {}
            : { "& .MuiCircularProgress-svg": { transform: "scaleY(-1)" } })
        }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Typography
          variant="caption"
          fontWeight="bold"
          sx={{ color: textColor, lineHeight: 1 }}
        >
          {hasValue ? (
            `${isPositive ? "+" : "-"}${Math.abs(value)}%`
          ) : (
            <Translate value="n_a" />
          )}
        </Typography>
      </Box>
    </Box>
  )
}

export default memo(PercentCircle)
